import React from "react";
import styled from "styled-components";
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from "recharts";

// Styled Tooltip Container
const StyledTooltip = styled.div`
  background-color: #333;
  color: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
`;

// Styled Label
const Label = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
`;

// Styled Item
const Item = styled.div`
  font-size: 12px;
`;

const CustomTooltip = ({ payload, label }) => {
  if (!payload || payload.length === 0) return null;

  const data = payload[0].payload; // Access the data for the tooltip

  return (
    <StyledTooltip>
      <Label>Date: {label}</Label>
      <Item>High Price: ${Number(data.high).toFixed(2)}</Item>
      <Item>Low Price: ${Number(data.low).toFixed(2)}</Item>
    </StyledTooltip>
  );
};

const normalizeData = (data) => {
  if (data.length === 0) return [];

  // Sort by date
  const sortedData = [...data].sort((a, b) => new Date(a.date) - new Date(b.date));

  // Convert to Date objects
  let filledData = [];
  let currentDate = new Date(sortedData[0].date);
  const lastDate = new Date(sortedData[sortedData.length - 1].date);
  
  // Convert data to a Map for quick lookup
  const dataMap = new Map(sortedData.map(item => [item.date, [item.high, item.low]]));

  // Loop through each day in the range
  while (currentDate <= lastDate) {
    const dateStr = currentDate.toISOString().split("T")[0]; // Format YYYY-MM-DD
    const [high, low] = dataMap.get(dateStr) ?? [null, null];
    filledData.push({ date: dateStr, high: high, low: low});

    // Move to next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return filledData;
};

const StockChart = ({ data }) => {
  data = normalizeData(data);
  let mx = Math.max(...data.map(d => d.high));
  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" tick={false} />
        <YAxis domain={[0, Math.ceil(1.2*mx/10) * 10]}/>
        <Tooltip content={<CustomTooltip />}/>
        <Line connectNulls={true} type="monotone" dataKey="high" stroke="#5c9e27" strokeWidth={1} />
        <Line connectNulls={true} type="monotone" dataKey="low" stroke="#b23e27" strokeWidth={1} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default StockChart;
